import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import ButtonNav from '../button/ButtonNav';

export default function CardCreneauMini({ creneau, actionSelectCreneau, displayPrix }) {

	return (
		<Grid container sx={{ p: 0, mb: 4, color: '#555555', borderRadius: 0, boxShadow: 10 }} direction="row" justifyContent="center" alignItems="center" >

			<Grid item xs={12} sx={{ p: 2, backgroundColor: '#004AFE' }}>
				<Typography sx={{ whiteSpace: "pre-line", color: '#FFFFFF', textAlign: 'center', fontSize: 22, fontWeight: 600 }}>
					{creneau.dateComplete}
				</Typography>
			</Grid>
			<Grid item xs={12} sx={{ p: 1, textAlign: 'center' }}>
				Horaires Début - Fin :<br />
				<Typography component="span" variant="slot">{creneau.heureRdvDebut} - {creneau.heureRdvFin}</Typography>
			</Grid>
			
			{displayPrix &&
				<Grid item xs={6} align="center">
					<Typography component="div" align="center" variant="price" sx={{ lineHeight: 1 }}>
						{creneau.tarif}<Typography component="span" align="center" variant="currency">€</Typography>
					</Typography>
					{creneau.montantOptions > 0 &&
						'hors option(s)'
					}
				</Grid>
			}

			<Grid item xs={12} align="center">
				<Box py={3} px={{ xs: 0, sm: 0, md: 3 }}>
					<ButtonNav props={{ text: 'Réserver', tracking: 'book-btn' }} action={() => actionSelectCreneau(creneau)} />
				</Box>
			</Grid>

		</Grid>
	);
}